import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';
import { IFullState } from '../types/All.type';
import { rolePermissions, MESSAGE } from '../constants/Permission';
import Unauthorized from '../components/Auth/UnAuthorized';

const UserAndRolesComp = React.lazy(() => import('../components/UserAndRoles'));

const UsersAndRolesContainer = styled.div`
  padding: 5px;
`;

function UserAndRoles(): ReactElement {
  const { permissions } = useSelector(
    (state: IFullState) => state.genesisUserRolePermission
  );
  return (
    <SuspenseLoadPage>
      {permissions.includes(rolePermissions.listUsersAndRoles) ? (
        <UsersAndRolesContainer>
          <UserAndRolesComp />
        </UsersAndRolesContainer>
      ) : (
        <Unauthorized message={MESSAGE.unAuthorized} backOption />
      )}
    </SuspenseLoadPage>
  );
}

export default UserAndRoles;
